import React from 'react';
import { userService } from '../../services/user.service';
import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';

class TestUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            users: []
        };
    }

    componentDidMount() {
        this.setTestUsers();
    }

    setTestUsers() {
        userService.getTestUsers().then(data => {
            if(data && data.length > 0) {
                this.setState({ users: data });
            } else {
                this.props.history.push('index');
            }
        });
    }

    getRefund = (event, user) => {
        event.preventDefault();
        axiosInstance.get(API_HOST + "/resource/test_users/" + user + "/refund", axiosRequestWithAuth)
            .then((resp) => {
                console.log(resp);
            })
            .catch((resp) => {
                alert("Failed to refund, try again");
            });
    };

    render() {
        return (
            <div className="test_User">
                <h2>Test Users</h2>
                <table>
                    <tr>
                        <th style={ { textAlign: "center" } }>First Name</th>
                        <th style={ { textAlign: "center" } }>Last Name </th>
                        <th style={ { textAlign: "center" } }>Email</th>
                        <th style={ { textAlign: "center" } }>Created on</th>
                        <th style={ { textAlign: "center" } }>Card</th>
                        <th style={ { textAlign: "center" } }>Action</th>
                    </tr>
                    {
                        this.state.users.map((elem, i) =>
                            <tr key={ i }>
                                <td style={ { textAlign: "center" } }>{ elem[0] } </td>
                                <td style={ { textAlign: "center" } }>{ elem[1] } </td>
                                <td style={ { textAlign: "center" } }>{ elem[2] } </td>
                                <td style={ { textAlign: "center" } }>{ elem[3] } </td>
                                <td style={ { textAlign: "center" } }>{ elem[4] }</td>
                                <td style={ { textAlign: "center" } }><button style={ { fontSize: "16px", backgroundColor: "lightblue", cursor: "pointer", border: '1px solid black', borderRadius: '5px' } } onClick={ (e) => { this.getRefund(e, elem[5]); } }>Refund</button></td>
                            </tr>
                        )
                    }
                </table>
            </div>
        );
    }
}

export default TestUser;
